import React, { useState } from "react";
import Header from "../../layouts/Header";
import { Card, Button, Container, Form } from "react-bootstrap";
import { useCustomerStore } from "../../hooks/Mantenimiento_Generales/useCustomerStore";
import rechazado from "../../styles/assets/img/rechazado.png";
import aprobado from "../../styles/assets/img/aprobado.png";
import pendiente from "../../styles/assets/img/pendiente.png";

export default function Standard() {
  const [customerId, setCustomerId] = useState("");
  const [userData, setUserData] = useState("");
  const [statusImage, setStatusImage] = useState("");
  const [daysRemaining, setDaysRemaining] = useState(null); // Para los días restantes
  const { getDataCustomerPayment } = useCustomerStore();

  const handleValidateCustomer = async (customerId) => {
    try {
      setDaysRemaining(0);
      const customerData = await getDataCustomerPayment(customerId);

      if (!customerData) {
        setStatusImage(pendiente);
        setUserData("");
        setDaysRemaining(null);
      } else if (customerData.statusPayment === "Paid") {
        setUserData(customerData);
        setStatusImage(aprobado);
        setCustomerId("");
      } else if (customerData.statusPayment === "Overdue") {
        setUserData(customerData);
        setStatusImage(rechazado);
        setCustomerId("");
      } else if (customerData.statusPayment === "Pending") {
        setUserData(customerData);
        setStatusImage(pendiente);
        setCustomerId("");
      }
// debugger
//       if (!customerData && customerData.next_payment_date) {
//         setDaysRemaining(0);
//       }

      // Calcular los días restantes hasta el siguiente pago
      if (customerData && customerData.next_payment_date) {
        const nextPaymentDate = new Date(customerData.next_payment_date);
        const currentDate = new Date();
        const diffTime = nextPaymentDate - currentDate;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convertir a días
        setDaysRemaining(diffDays);
      }

    } catch (error) {
      console.log("Error al validar el estado: " + error);
    }
  };

  return (
    <React.Fragment>
      <Header />

      <Container
        fluid
        className="d-flex justify-content-center align-items-center"
        style={{ backgroundColor: "#f8f9fa", padding: "2rem" }}
      >
        <Card className="p-4 shadow" style={{ width: "40rem" }}>
          <h2 className="text-center mb-4">Verificar Usuario</h2>

          <Form>
            <Form.Group controlId="formCustomerId" className="mb-3">
              <Form.Label>Identificación del Cliente</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese la cédula"
                value={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
              />
            </Form.Group>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <Button
                variant="primary"
                onClick={() => handleValidateCustomer(customerId)}
              >
                Validar
              </Button>
            </div>

            <hr />

            <Form.Group controlId="formCustomerName" className="mb-3">
              <div
                className="d-flex flex-column flex-md-row align-items-center"
                style={{ gap: "15px" }}
              >
                {/* Imagen (logo) */}
                {statusImage && (
                  <img
                    src={statusImage}
                    alt="Status"
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: "40px",
                    }}
                    className="mb-3 mb-md-0" // Margen inferior solo en móviles
                  />
                )}

                {/* Contenedor de Nombre y Estado de Pago */}
                <div style={{ flex: 1, width: "100%" }}>
                  {/* Nombre */}
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "10px", marginBottom: "10px" }}
                  >
                    <span style={{ width: "120px" }}>Nombre:</span>
                    <Form.Control
                      type="text"
                      placeholder="Usuario no encontrado"
                      value={userData?.name || ""}
                      disabled
                      style={{ flex: 1 }}
                    />
                  </div>

                  {/* Identificación */}
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "10px", marginBottom: "10px" }}
                  >
                    <span style={{ width: "120px" }}>Identificación:</span>
                    <Form.Control
                      type="text"
                      placeholder="Usuario no encontrado"
                      value={userData?.identification || ""}
                      disabled
                      style={{ flex: 1 }}
                    />
                  </div>

                  {/* Estado de Pago */}
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "10px", marginBottom: "10px" }}
                  >
                    <span style={{ width: "120px" }}>Estado:</span>
                    <Form.Control
                      type="text"
                      placeholder="Usuario no encontrado"
                      value={
                        userData?.statusPayment === "Paid"
                          ? "Pagado"
                          : userData?.statusPayment === "Overdue"
                          ? "Vencido"
                          : userData?.statusPayment === "Pending"
                          ? "Pendiente"
                          : ""
                      }
                      disabled
                      style={{ flex: 1 }}
                    />
                  </div>

                  {/* Mostrar días restantes y fecha de siguiente pago */}
                  {daysRemaining !== null && (
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px", marginBottom: "10px" }}
                    >
                      <span style={{ width: "120px" }}>Días restantes:</span>
                      <Form.Control
                        type="text"
                        placeholder="0 días restantes"
                        value={daysRemaining + " días"}
                        disabled
                        style={{ flex: 1 }}
                      />
                    </div>
                  )}

                  {userData?.next_payment_date && (
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px" }}
                    >
                      <span style={{ width: "120px" }}>Próximo pago:</span>
                      <Form.Control
                        type="text"
                        value={new Date(userData.next_payment_date).toLocaleDateString()}
                        disabled
                        style={{ flex: 1 }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Form.Group>
          </Form>
        </Card>
      </Container>
    </React.Fragment>
  );
}